var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	if ("undefined" == typeof newListClass){
		var newListClass  = '';
	}
	

__p+='\n<div class="daily-list '+
((__t=(newListClass))==null?'':__t)+
'">\n	\n	<div class="act-time">'+
((__t=(UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime * 1000, cfg.endTime * 1000, UpAct.lang.lang)))==null?'':__t)+
'</div>	\n	';

		if(showCountDown){
	
__p+='\n	<div class="countdown J-Countdown" id="J-Countdown" >\n		<h2>'+
((__t=(lang.template('今日榜单活动结束还有')))==null?'':__t)+
'</h2>\n		<div class="main">\n			<em node-id="day">0</em><span>'+
((__t=(lang.template('天')))==null?'':__t)+
'</span>\n			<em node-id="hour">00</em><span>'+
((__t=(lang.template('小时')))==null?'':__t)+
'</span>\n			<em node-id="minute">00</em><span>'+
((__t=(lang.template('分钟')))==null?'':__t)+
'</span>\n			<em node-id="second">00</em><span>'+
((__t=(lang.template('秒')))==null?'':__t)+
'</span>\n		</div>\n	</div>\n	';

		}
	
__p+='\n	<div class="list">\n		<div class="list" node-id="list" data-pagesize="10" data-params="{area:\''+
((__t=(actInfo.area))==null?'':__t)+
'\', eventId:\''+
((__t=(cfg.id))==null?'':__t)+
'\',activityId:\''+
((__t=(actInfo.id))==null?'':__t)+
'\'}"></div>\n		<div class="ui-tip hidden" node-id="loading">'+
((__t=(UpAct.lang.template('正在加载数据...')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="end">'+
((__t=(UpAct.lang.template('没有更多数据了哦')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="error">'+
((__t=(UpAct.lang.template('系统异常')))==null?'':__t)+
'</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/createTabAndList/daily-list.tmpl
// module id = 81
// module chunks = 0